"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOURCE_TYPE_PREFIX_SCOPE_MAP = exports.RESOURCE_TYPE_APP = exports.RESOURCE_TYPE_S3_BUCKET_PREFIX = exports.RESOURCE_TYPE_CASSANDRA_KEYSPACE_PREFIX = exports.RESOURCE_TYPE_HABITAT_PREFIX = exports.S3_BUCKET_SCOPES = exports.S3_BUCKET_SCOPE_IDS = exports.RESOURCE_TYPE_DASHBOARD_DATA_MANAGEMENT_SUFFIX = exports.RESOURCE_TYPE_DASHBOARD_ORCHESTRATION_SUFFIX = exports.RESOURCE_TYPE_DASHBOARD_WORKBENCH_COLLAB_SUFFIX = exports.RESOURCE_TYPE_DASHBOARD_APPS_SUFFIX = exports.RESOURCE_TYPE_DASHBOARD_MODEL_MANAGEMENT_SUFFIX = exports.RESOURCE_TYPE_DASHBOARD_COMPONENT_PREFIX = exports.CASSANDRA_KEYSPACE_SCOPES = exports.CASSANDRA_KEYSPACE_SCOPE_IDS = exports.HABITAT_SCOPES = exports.DASHBOARD_COMPONENT_SCOPES = exports.DASHBOARD_COMPONENT_SCOPE_IDS = exports.bucketFromResource = exports.s3ResourceType = exports.keyspaceNameFromResource = exports.cassandraResourceType = exports.s3BucketResourceName = exports.appResourceName = exports.isHabitatGroup = exports.habitatFromGroupName = exports.habitatGroupName = exports.habitatResourceName = exports.adminRoleName = void 0;
exports.adminRoleName = 'altasigma-admin';
var habitatResourceName = function (habitatCode) {
    return "habitat:".concat(habitatCode);
};
exports.habitatResourceName = habitatResourceName;
var habitatGroupName = function (habitatCode, permission) { return "habitat:".concat(habitatCode, ":").concat(permission); };
exports.habitatGroupName = habitatGroupName;
var habitatFromGroupName = function (groupName) {
    return (0, exports.isHabitatGroup)(groupName) ? groupName.split(':')[1] : groupName;
};
exports.habitatFromGroupName = habitatFromGroupName;
var habitatGroupRegex = /habitat:[0-9A-z]+:(view|edit)/;
var isHabitatGroup = function (groupName) {
    return habitatGroupRegex.test(groupName);
};
exports.isHabitatGroup = isHabitatGroup;
var appResourceName = function (appCode) {
    return "".concat(exports.RESOURCE_TYPE_APP, ":").concat(appCode);
};
exports.appResourceName = appResourceName;
var s3BucketResourceName = function (dataSourceCode, bucketName) {
    return "".concat(exports.RESOURCE_TYPE_S3_BUCKET_PREFIX, ":").concat(dataSourceCode, ":").concat(bucketName);
};
exports.s3BucketResourceName = s3BucketResourceName;
var cassandraResourceType = function (dataSourceCode) {
    return "".concat(exports.RESOURCE_TYPE_CASSANDRA_KEYSPACE_PREFIX, ":").concat(dataSourceCode);
};
exports.cassandraResourceType = cassandraResourceType;
/** Extract datapool_0qty21s from cassandra:GEYDAMBQGA:datapool_0qty21s */
var keyspaceNameFromResource = function (resource) {
    return resource.split(':')[2];
};
exports.keyspaceNameFromResource = keyspaceNameFromResource;
var s3ResourceType = function (dataSourceCode) {
    return "".concat(exports.RESOURCE_TYPE_S3_BUCKET_PREFIX, ":").concat(dataSourceCode);
};
exports.s3ResourceType = s3ResourceType;
/** Extract test-bucket from s3-bucket:GEYDAMBQGA:test-bucket */
var bucketFromResource = function (resource) {
    return resource.split(':')[2];
};
exports.bucketFromResource = bucketFromResource;
/**
 * Allowed scopes for the dashboard components
 */
exports.DASHBOARD_COMPONENT_SCOPE_IDS = {
    ACCESS: 'dashboard-component:access',
};
exports.DASHBOARD_COMPONENT_SCOPES = [
    { id: exports.DASHBOARD_COMPONENT_SCOPE_IDS.ACCESS, displayName: 'Access' },
];
/**
 * Allowed scopes for the Habitats
 */
exports.HABITAT_SCOPES = {
    VIEW: 'scopes:view',
    EDIT: 'scopes:edit',
};
/**
 * Allowed scopes for the Cassandra Keyspaces
 */
exports.CASSANDRA_KEYSPACE_SCOPE_IDS = {
    CREATE: 'cassandra:create',
    SELECT: 'cassandra:select',
    ALTER: 'cassandra:alter',
    DROP: 'cassandra:drop',
    EXECUTE: 'cassandra:execute',
    MODIFY: 'cassandra:modify',
};
exports.CASSANDRA_KEYSPACE_SCOPES = [
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.SELECT, displayName: 'Select' },
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.CREATE, displayName: 'Create' },
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.ALTER, displayName: 'Alter' },
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.DROP, displayName: 'Drop' },
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.EXECUTE, displayName: 'Execute' },
    { id: exports.CASSANDRA_KEYSPACE_SCOPE_IDS.MODIFY, displayName: 'Modify' },
];
exports.RESOURCE_TYPE_DASHBOARD_COMPONENT_PREFIX = 'dashboard-component';
exports.RESOURCE_TYPE_DASHBOARD_MODEL_MANAGEMENT_SUFFIX = 'model-management';
exports.RESOURCE_TYPE_DASHBOARD_APPS_SUFFIX = 'apps';
exports.RESOURCE_TYPE_DASHBOARD_WORKBENCH_COLLAB_SUFFIX = 'workbench-collab';
exports.RESOURCE_TYPE_DASHBOARD_ORCHESTRATION_SUFFIX = 'orchestration';
exports.RESOURCE_TYPE_DASHBOARD_DATA_MANAGEMENT_SUFFIX = 'data-management';
/**
 * Allowed scopes for the S3 Buckets
 */
exports.S3_BUCKET_SCOPE_IDS = {
    READ: 's3:read',
    WRITE: 's3:write',
};
exports.S3_BUCKET_SCOPES = [
    { id: exports.S3_BUCKET_SCOPE_IDS.READ, displayName: 'Read' },
    { id: exports.S3_BUCKET_SCOPE_IDS.WRITE, displayName: 'Write' },
];
exports.RESOURCE_TYPE_HABITAT_PREFIX = 'habitat';
exports.RESOURCE_TYPE_CASSANDRA_KEYSPACE_PREFIX = 'cassandra-keyspace';
exports.RESOURCE_TYPE_S3_BUCKET_PREFIX = 's3-bucket';
exports.RESOURCE_TYPE_APP = 'app';
/**
 * Mapping of resource type prefixes to the available scopes
 */
exports.RESOURCE_TYPE_PREFIX_SCOPE_MAP = (_a = {},
    _a[exports.RESOURCE_TYPE_APP] = Object.values(exports.DASHBOARD_COMPONENT_SCOPE_IDS),
    _a[exports.RESOURCE_TYPE_CASSANDRA_KEYSPACE_PREFIX] = Object.values(exports.CASSANDRA_KEYSPACE_SCOPE_IDS),
    _a[exports.RESOURCE_TYPE_HABITAT_PREFIX] = Object.values(exports.HABITAT_SCOPES),
    _a[exports.RESOURCE_TYPE_DASHBOARD_COMPONENT_PREFIX] = Object.values(exports.DASHBOARD_COMPONENT_SCOPE_IDS),
    _a[exports.RESOURCE_TYPE_S3_BUCKET_PREFIX] = Object.values(exports.S3_BUCKET_SCOPE_IDS),
    _a);
//# sourceMappingURL=keycloak.js.map